import { lazy } from 'react';
import { homePage, loginPagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';
import { RouteDefinition } from '../types/route-definition-type';

const LANDING = {
	HOMEPAGE: lazy(() => import('../layout/Page/Homepage')),
};

const USERS = {
	USERS: lazy(() => import('../pages/presentation/admin/users/UsersPage')),
};

const COMMON = {
	COMMON_HOMEPAGE: lazy(() => import('../pages/presentation/common/homepage/CommonHomepagePage')),
};

const HISTORY_FILE = {
	HISTORY_FILE: lazy(() => import('../pages/presentation/admin/history-files/HistoryFilePage')),
};

const TRACK_NUMBER = {
	TRACK_NUMBER: lazy(() => import('../pages/presentation/admin/track-number/TrackNumberPage')),
};

const BLACKLIST = {
	BLACKLIST: lazy(() => import('../pages/presentation/admin/blacklist/BlacklistPage')),
};

const presentation: RouteDefinition[] = [
	{
		id: 'users',
		path: 'users',
		element: <USERS.USERS />,
	},
	{
		id: 'history-file',
		path: 'history-file',
		element: <HISTORY_FILE.HISTORY_FILE />,
	},
	{
		id: 'track-number',
		path: 'track-number',
		element: <TRACK_NUMBER.TRACK_NUMBER />,
	},
	{
		id: 'blacklist',
		path: 'blacklist',
		element: <BLACKLIST.BLACKLIST />,
	},
	{
		id: 'homepage',
		path: 'home-page',
		element: <COMMON.COMMON_HOMEPAGE />,
	},
	{
		id: 'homepage',
		path: homePage.login.path,
		element: <LANDING.HOMEPAGE />,
	},
	{
		id: 'home',
		path: '/',
		element: <LANDING.HOMEPAGE />,
	},
	{
		id: 'login',
		path: loginPagesMenu.login.path,
		element: <Login />,
	},
];
const contents = [...presentation];

export default contents;
